import {
  submissionConfirmationHref,
  type SubmissionConfirmation,
} from "@shared/submissionConfirmation";

/** Called only after an acknowledged successful write, never on validation/error. */
export function redirectAfterSubmission(confirmation?: SubmissionConfirmation): boolean {
  if (confirmation?.mode !== "page") return false;
  const hosted = /^\/p\/[^/]+/.exec(window.location.pathname);
  const href = submissionConfirmationHref(confirmation.destination, hosted?.[0] ?? "/");
  if (!href) return false;
  window.location.assign(href);
  return true;
}
